import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import NsfCompetitionDetail from './detail';

// Bottom drawer with one NSF competition (opened from the terminliste list, map and
// calendar). The drawer frame has the close button. The full page /terminliste/:id stays as the shareable link.
@observer
class NsfCompetitionDetailDrawer extends Component {
    render() {
        const { stores, id, drawerLevel = 1 } = this.props;
        return (
            <div class='container py-3' style='padding-bottom: 80px;'>
                <h5 class='mb-3'><Text id='terminliste.competition'>Competition</Text></h5>
                <NsfCompetitionDetail stores={stores} id={id} inDrawer={true} drawerLevel={drawerLevel} />
            </div>
        );
    }
}

export default NsfCompetitionDetailDrawer;
